import { PATHS } from '../config'
import {
  ARTICLE,
  CATEGORY,
  DAY,
  MONTH,
  PAGE,
  TAG,
  YEAR,
} from '../constants'

import {
  buildArticlePermalink,
  buildCategoryPermalink,
  buildDayPermalink,
  buildMonthPermalink,
  buildPagePermalink,
  buildTagPermalink,
  buildYearPermalink,
} from './urls'

const TYPE_MAP = {
  [DAY]: buildDayPermalink,
  [MONTH]: buildMonthPermalink,
  [YEAR]: buildYearPermalink,
  [ARTICLE]: buildArticlePermalink,
  [CATEGORY]: buildCategoryPermalink,
  [TAG]: buildTagPermalink,
  [PAGE]: buildPagePermalink,
}

export function buildPagination(type, params = {}) {
  const {
    page,
    hasNext,
    hasPrev,
    year,
    month,
    day,
    slug,
    slugs,
    archives = PATHS.ARCHIVES,
  } = params

  const builder = TYPE_MAP[type]

  const rel = { archives }

  if (!builder) {
    return rel
  }

  if (hasPrev) {
    rel.prev = builder({
      year,
      month,
      day,
      slug,
      slugs,
      page: page - 1,
    })
  }

  if (hasNext) {
    rel.next = builder({
      year,
      month,
      day,
      slug,
      slugs,
      page: page + 1,
    })
  }

  return rel
}
